import { Resume } from '@sr/types';
import * as React from 'react';
import { Box, Button } from '../../ui';
import LinkedinImportForm from '../linkedin-import/LinkedinImportForm';

export default function LinkedinImportPrompt({
  addSectionItem,
  resume,
}: {
  addSectionItem: () => void;
  resume: Resume;
}) {
  return (
    <Container>
      <LinkedinImportForm
        inputLabel="Import from LinkedIn with your profile URL"
        resumeId={resume.id}
        smallButton={true}
        userId={resume.owner}
        location="editor"
      />
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ color: 'black50' }}>Or</Box>
        <Button
          variant="link"
          onClick={addSectionItem}
          data-testid="skip-linkedin-import"
        >
          Add manually
        </Button>
      </Box>
    </Container>
  );
}

function Container({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        width: '100%',
        p: 16,
        mb: 5,
        borderColor: 'buttonGray',
        borderStyle: 'solid',
        borderWidth: 1,
      }}
    >
      {children}
    </Box>
  );
}
